import React from "react";
import CommonTooltip from "../../common/CommonTooltip";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Tab } from "@fluentui/react-components";
import MenuRow from "./MenuRow";
import {
  AlignCenter,
  BordersNone,
  BorderStyleMenu,
  ColorFillMenu,
  IconsMenu,
  ImageMenu,
  InsertMenu,
  ShapesMenu,
  SpacerWidthMenu,
  StructureMenu,
  TextMenu,
} from "../../../assets/icons";
import { useGoogleAnalytics } from "@connectaryal/google-analytics";
import { useDispatch } from "react-redux";
import { setLastOpenAccordionItem } from "../../../state/appStateSlice";

const iconStyle = { width: 20, height: 20 };

const idToIcon = {
  merge: <StructureMenu style={iconStyle} />,
  image: <ImageMenu style={iconStyle} />,
  shape: <ShapesMenu style={iconStyle} />,
  icon: <IconsMenu style={iconStyle} />,
  background: <ColorFillMenu style={iconStyle} />,
  style: <TextMenu style={iconStyle} />,
  borders: <BordersNone style={iconStyle} />,
  align: <AlignCenter style={iconStyle} />,
  structure: <InsertMenu style={iconStyle} />,
  spacer: <SpacerWidthMenu style={iconStyle} />,
  preset: <BorderStyleMenu style={iconStyle} />,
};

const ContextMenuTab = ({ id, value, label, onClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { trackEngagement } = useGoogleAnalytics();
  const dispatch = useDispatch();

  return (
    <Tab
      id={id}
      value={value}
      onClick={(e) => {
        if (onClick) onClick(e);
        dispatch(setLastOpenAccordionItem(id));
        trackEngagement({ type: "click", options: { id: `${id}_context_menu` } });
      }}
      className={classes.TabHeader}
      style={{ borderRadius: 0, background: "#E4E4E4" }}
    >
      <MenuRow>
        <CommonTooltip content={t(label + ".tooltip")} positioning="before">
          <div className={classes.TextHeader}>{idToIcon[value]}</div>
        </CommonTooltip>
      </MenuRow>
    </Tab>
  );
};

ContextMenuTab.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ContextMenuTab;
